module.exports = __webpack_public_path__ + "static/media/icn_landing_card_1.e7718d67.svg";